import { render, staticRenderFns } from "./checkboxItemPop.vue?vue&type=template&id=46d87574&scoped=true"
import script from "./checkboxItemPop.vue?vue&type=script&lang=js"
export * from "./checkboxItemPop.vue?vue&type=script&lang=js"
import style0 from "./checkboxItemPop.vue?vue&type=style&index=0&id=46d87574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d87574",
  null
  
)

export default component.exports